// extracted by mini-css-extract-plugin
export var activeDot = "_8x-c";
export var buttonContainer = "_8x-9";
export var channelButton = "_8x-a";
export var clickable = "_8x-d";
export var content = "_8x-0";
export var contentFull = "_8x-2";
export var contentThird = "_8x-1";
export var contentWrapper = "_8x-7";
export var description = "_8x-5";
export var heightShort = "_8x-f";
export var image = "_8x-3";
export var imageContainer = "_8x-4";
export var selectButton = "_8x-e";
export var spinnerContainer = "_8x-b";
export var titleContent = "_8x-8";
export var titleWrapper = "_8x-6";